import React, { Component } from 'react'
import {Row, Col} from 'react-flexbox-grid'
import CSSModules from 'react-css-modules'
import Styles from './Footer.css'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  IyvBanner,
  SignupForm,
  FooterPartner,
} from '../../components'

@CSSModules(Styles)
export default class Footer extends Component {
  // static propTypes = {
  // }
  // constructor(props){
  //   super(props);
  // }
  render() {
    const aysLogo = require( '../../../static/images/AYS_R+large+RGB.jpg' )
    const blueskyLogo = require( '../../../static/images/bluesky_logo_white.svg' )
    const blueskyLogoHover = require( '../../../static/images/bluesky_logo_light_purple.svg' )

    //
    return <section>
      <IyvBanner />
      <SignupForm />
      <div styleName='footer-wrap'>
        <ContainerDivs>
          <Row>
            <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
              <div styleName='logo-first-wrap'>
                <Link
                  to={config.links.ays}
                  title='As You Sow'
                  >
                  <img
                    styleName={'logo-ays'}
                    src={aysLogo}
                    alt='As You Sow'
                  />
                </Link>
                { /* <div styleName='footer-donate-tagline'>
                  Empowering shareholders<br/>to change corporations for good
                </div> */ }
                <div styleName='footer-social-icons-item'>
                  <Link
                    to={config.links.socialAYSlinkedin}
                    title='As You Sow LinkedIn'
                  >
                    <i styleName='footer-social-icon' className='fa fa-linkedin-square'/>
                  </Link>
                  <Link
                    to={config.links.socialAYSbluesky}
                    title='As You Sow Bluesky'
                  >
                    <img
                      src={blueskyLogo}
                      alt='As You Sow Bluesky'
                      styleName='bluesky-logo'
                    />
                  </Link>
                </div>
              </div>
            </Col>

            <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
              { /* <div styleName='footer-signup-headline'>
                Support this work
              </div> */ }
              <Link
                to={config.links.donate}
                orangebutton
                title='Donate to As You Sow'>
                Donate<LinkIcon faclass='fa-heart'
              />
              </Link>
              { /* <div styleName='footer-signup-tagline'>
                <span styleName='nowrap'>{ config.app.title }</span> is funded by contributions to <span styleName='nowrap'>As You Sow</span>, a <span styleName='nowrap'>non-profit 501(c)3</span>
              </div> */ }
            </Col>

            <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
              <FooterPartner />
            </Col>

          </Row>

          <div styleName='footer-disclaimer-links'>
            <Link
              to={config.routes.legal}
              title='Legal'>
              <span styleName='white'>Legal</span>
            </Link>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <Link
              to={config.links.contact}
              title='Contact'>
              <span styleName='white'>Contact</span>
            </Link>
          </div>
          <p styleName='footer-copyright-text'>
            Copyright &copy; {new Date().getFullYear()} As You Sow
          </p>
        </ContainerDivs>
      </div>
    </section>
  }
}